const hidePhone = (phone) => {
  return phone.slice(0, 3) + "xxx" + phone.slice(-4);
};

export default {
  hidePhone,
};
